import { render } from "./updateStudentFaceView.vue?vue&type=template&id=20c62c32&scoped=true"
import script from "./updateStudentFaceView.vue?vue&type=script&lang=js"
export * from "./updateStudentFaceView.vue?vue&type=script&lang=js"

import "./updateStudentFaceView.vue?vue&type=style&index=0&id=20c62c32&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c62c32"]])

export default __exports__